<template>
  <nav class="mode_switch_bar" :class="[theme]">
    <button
      id="normalMode"
      class="switch-btn"
      :class="{ active: activeMode == 'normal' }"
      @click="switchMode('normal')"
    ></button>
    <button
      id="dataEditMode"
      class="switch-btn"
      :class="{ active: activeMode == 'dataEdit' }"
      @click="switchMode('dataEdit')"
    ></button>
    <button
      id="styleEditMode"
      class="switch-btn"
      :class="{ active: activeMode == 'styleEdit' }"
      @click="switchMode('styleEdit')"
    ></button>
  </nav>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "ModeSwitchBar",
  data() {
    return {
      activeMode: "normal",
    };
  },
  methods: {
    switchMode(mode) {
      this.activeMode = mode;
      console.log(mode);
      console.log(this.managerMode);

      this.setManagerMode(mode);
      this.$emit("managerMode", mode);
    },
    ...mapMutations({
      setManagerMode: "setManagerMode",
    }),
  },
  computed: {
    ...mapGetters({
      managerMode: "managerMode",
    }),
  },
};
</script>
<style lang="css" scoped>
@import url(@/assets/style/components/modeSwitchBar/modeSwitchBar.css);
</style>
